"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("./error");
const getQuery = (locale) => {
    const query = [];
    if (locale)
        query.push(`locale=${locale}`);
    return query.join('&');
};
const handleEmptyResponse = (body) => {
    if (!Object.keys(body).length)
        throw (0, error_1.emptyBodyError)(body);
    return body;
};
const handleInvalidResponse = (res) => {
    if (!res.ok)
        throw (0, error_1.notOkError)(res);
    const contentType = res.headers.get('content-type');
    const isJson = (contentType === null || contentType === void 0 ? void 0 : contentType.indexOf('application/json')) !== -1;
    if (!isJson)
        throw (0, error_1.notJsonError)(contentType);
};
const fetchTranslations = async (query) => {
    const res = await fetch(`/api/translate?${query}`);
    handleInvalidResponse(res);
    const body = await res.json();
    return handleEmptyResponse(body);
};
const getTranslations = (locale) => fetchTranslations(getQuery(locale));
exports.default = getTranslations;
